import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { SvgUri } from 'react-native-svg';
import { FontAwesome6 } from '@expo/vector-icons';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import CdnImage from '../../common/CdnImage';
import { H6 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

export const ThePostPlusImage = ({
    caption,
    date,
    icon,
    iconColor = '#fff',
    instagramImage,
    nodeTypeAlias = 'SocialPostContainer.ThePostPlusImage',
    socialHandle,
    width,
    hardWidth,
    ...rest
}) => {
    const { layout } = useContext(LayoutContext);
    const iconSrc = icon?.cdnImagePath;
    const instagramImageSrc = instagramImage?.cdnImagePath;
    let iconCmp = null;

    if (iconSrc) {
        if (layout.device.os.equals('web')) {
            iconCmp = <CdnImage uri={`https:${iconSrc}`} style={{ height: 48, paddingRight: layout.styleGuide.marginHorizontal }} width={48} />;
        } else {
            iconCmp = <SvgUri uri={`https:${iconSrc}`} height={48} width={48} style={{ paddingRight: layout.styleGuide.marginHorizontal }} />;
        }
    } else if (instagramImageSrc) {
        iconCmp = <FontAwesome6 name='instagram-square' size={48} color={iconColor} style={{ paddingRight: layout.styleGuide.marginHorizontal }} />;
    }

    return (
        <View
            style={StyleSheet.flatten(layout.device.isMobile ? Styles.containerMobile : Styles.container, { maxWidth: layout.device.isMobile ? undefined : width })}
            dataSet={{ umbracoComponentName: nodeTypeAlias }}
        >
            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    paddingHorizontal: Math.floor(layout.styleGuide.spacer1 * 2),
                    width: layout.device.isMobile ? width : Math.floor(width * 0.5),
                    marginBottom: layout.device.isMobile ? layout.styleGuide.spacer3 : undefined
                }}
            >
                <View style={StyleSheet.flatten(Styles.handleContainer, { marginBottom: Math.floor(layout.styleGuide.spacer2 * 2) })}>
                    {iconCmp}
                    <H6
                        numberOfLines={2}
                        style={{ marginLeft: layout.styleGuide.spacer3 }}
                        text={`@${socialHandle} - ${format(typeof date === 'string' ? parseISO(date) : new Date(date), 'MMM do')}`}
                        dataSet={{ spacerLeft: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                    />
                </View>
                <View>
                    <H6 numberOfLines={50} text={caption} />
                </View>
            </View>
            {!!instagramImageSrc && <CdnImage uri={`https:${instagramImageSrc}`} width={layout.device.isMobile ? hardWidth : Math.floor(hardWidth * 0.5)} />}
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',
        flex: 2,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    containerMobile: {
        alignItems: 'center',
        backgroundColor: '#fff',
        flex: 1,
        flexDirection: 'column'
    },
    handleContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center'
    }
});

ThePostPlusImage.propTypes = {
    caption: PropTypes.string,
    date: PropTypes.string,
    instagramImage: PropTypes.object,
    socialHandle: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
